import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  GET_ALL_SUCCESS,
  SEARCH,
  SET_LOADING_SELECTS,
  GET_ALL_SELECTS_SUCCESS
} from './control-notifications-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSelects: true,
  list: {
    hasRemotePagination: true,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    selects: {},
    order: 'asc',
    orderBy: 'createdAt'
  }
};

const controlNotificationsReducer = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: [...action.payload.rows],
          allRows: [...action.payload.rows],
          rowsCount: action.payload.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_ALL_SELECTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          selects: {
            ...state.list.selects,
            vendors: action.payload?.selects?.vendors
          }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ROWS_ORIENTATION: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsOrientation: action.rowsOrientation
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case SEARCH: {
      const { queryString } = action;

      const results =
        queryString !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item?.subordinateUserId?.user?.name?.toLowerCase().startsWith(queryString) ||
                item?.subordinateUserId?.user?.name?.includes(queryString) ||
                item?.subordinateUserId?.user?.email?.toLowerCase().startsWith(queryString) ||
                item?.subordinateUserId?.user?.email?.toLowerCase().includes(queryString) ||
                item?.subordinateUserId?.user?.externalCode?.toLowerCase().startsWith(queryString) ||
                item?.subordinateUserId?.user?.externalCode?.toLowerCase().includes(queryString)
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    default:
      return state;
  }
};

export default controlNotificationsReducer;
